import { gql } from 'graphql-request'

export const GetPricesForProductQuery = {
	identifier: 'get_prices_for_product',
	gql: gql`
		query getPricesForProduct($product_id: ID!) {
			getPricesForProduct(product_id: $product_id) {
				id
				price
				product_id
				unit_of_measure
				is_expired
				formulary {
					id
					name
					is_managed
					owner_id
					is_static
					is_live
				}
			}
		}
	`,
	formatResults: (data) => {
		return data?.getPricesForProduct
	},
}
